export default __webpack_public_path__ + "static/media/profil.4e35225c.svg";